import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/wechat.png'
import _imports_1 from '@/assets/img/alipay.png'


const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "vip-tab" }
const _hoisted_3 = { style: {"margin":"10px 0"} }
const _hoisted_4 = {
  key: 0,
  class: "vip-card"
}
const _hoisted_5 = { class: "title1" }
const _hoisted_6 = { class: "title2" }
const _hoisted_7 = { class: "title3" }
const _hoisted_8 = { class: "activeColor" }
const _hoisted_9 = {
  key: 0,
  class: "vip-card-top"
}
const _hoisted_10 = {
  key: 1,
  class: "vip-card"
}
const _hoisted_11 = { class: "title1" }
const _hoisted_12 = { class: "title2" }
const _hoisted_13 = { class: "title3" }
const _hoisted_14 = { class: "vip-payway" }
const _hoisted_15 = { style: {"margin-top":"10px","text-align":"center"} }
const _hoisted_16 = ["srcdoc"]
const _hoisted_17 = { style: {"text-align":"center"} }

import purchaseHistoryDialog from "./purchaseHistoryDialog.vue"
import { ref, reactive, onMounted, nextTick } from 'vue';
import { getVipType, toZhiFuBaoPay, toWexinPay } from "@/api/common.js"
import QRCode from "qrcode";
import { ElMessage } from 'element-plus'
import { useStore } from "vuex"
import { useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'purchaseDialog',
  props: {
    popupShow: {
        type: Boolean,
        default: false
    },
    type: {
        type: String,
        default: 'vip'
    }
},
  emits: ['close', 'wxpaySuccess'],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const store = useStore();
const props = __props
const dialogShow = ref(props.popupShow)
const purchaseType = ref('vip')
const payWay = ref('wechat')
const payType = ref({})
let initIndex = ref(0)
const alipayHtml = ref()
const alipayShow = ref(false)
const historyShow = ref(false)
const wechatShow = ref(false)
const wechatUrl = ref()
const emitList = __emit


function closeEvent() {
    emitList('close')
}

function getTypeList() {
    getVipType({}).then(res => {
        let typeList = (res.data || []).filter(item => {
            return item.memberCardType != 4
        });
        let timeList = (res.data || []).filter(item => {
            return item.memberCardType == 4
        });
        payType.value.vip = typeList
        payType.value.ai = timeList
    })
}

function cardChange(val) {
    initIndex.value = val;
    console.log(initIndex.value)
}

function confirmEvent() {
    const vipList = payType.value[purchaseType.value]
    console.log(vipList)
    const memberId = vipList[initIndex.value].memberId
    console.log(memberId, payWay.value)
    if (payWay.value == 'alipay') {
        toZhiFuBaoPay(memberId).then(res => {
            alipayHtml.value = res.data
            alipayShow.value = true
        })
    } else if (payWay.value == 'wechat') {
        toWexinPay(memberId).then(res => {
            wechatShow.value = true
            QRCode.toCanvas(res.data.codeUrl, {
                width: 350,
                height: 350,
            }).then((rescode) => {
                nextTick(() => {
                    const box = document.getElementById("qrcode");
                    box.innerHTML = '';
                    box.appendChild(rescode);
                });
            });
        })
    }
}

function wechatClose() {
    wechatShow.value = false
    wechatUrl.value = ''
}

function wxpaySuccess() {
    wechatShow.value = false
    wechatUrl.value = ''
    emitList('wxpaySuccess')
}

function alipayClose() {
    alipayShow.value = false
    alipayHtml.value = ''

}

onMounted(() => {
    purchaseType.value = props.type
    getTypeList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: dialogShow.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogShow).value = $event)),
      width: "400px",
      title: "VIP与AI次数购买",
      "append-to-body": "",
      center: "",
      onClose: closeEvent,
      "modal-class": "dialog-new-model"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_radio_group, {
              modelValue: purchaseType.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((purchaseType).value = $event)),
              fill: "#ef8b25",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_isRef(initIndex) //@ts-ignore
 ? initIndex.value = 0 : initIndex=0))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_button, {
                  label: "VIP续期",
                  value: "vip"
                }),
                _createVNode(_component_el_radio_button, {
                  label: "AI次数购买",
                  value: "ai"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_carousel, {
              autoplay: false,
              type: "card",
              height: "180px",
              onChange: cardChange,
              "pause-on-hover": false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payType.value[purchaseType.value], (item) => {
                  return (_openBlock(), _createBlock(_component_el_carousel_item, {
                    key: item.memberId
                  }, {
                    default: _withCtx(() => [
                      (purchaseType.value=='vip')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(item.memberName), 1),
                            _createElementVNode("div", _hoisted_6, "￥" + _toDisplayString(item.discountPrice), 1),
                            _createElementVNode("div", _hoisted_7, "￥" + _toDisplayString(item.originalPrice), 1),
                            _createElementVNode("div", _hoisted_8, "购买送" + _toDisplayString(item.memberAiTimes) + "次AI调用次数", 1),
                            (item.isFirst)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, "首月特惠"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (purchaseType.value=='ai')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(item.memberAiTimes) + "次", 1),
                            _createElementVNode("div", _hoisted_12, "￥" + _toDisplayString(item.discountPrice), 1),
                            _createElementVNode("div", _hoisted_13, "￥" + _toDisplayString(item.originalPrice), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "vip-payway-title" }, "支付方式：", -1)),
            _createVNode(_component_el_radio_group, {
              modelValue: payWay.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payWay).value = $event)),
              class: "vip-payway-radio"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  value: "wechat",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createElementVNode("img", {
                      style: {"width":"20px","height":"20px","margin-right":"5px"},
                      src: _imports_0
                    }, null, -1),
                    _createTextVNode(" 微信支付 ")
                  ])),
                  _: 1,
                  __: [8]
                }),
                _createVNode(_component_el_radio, {
                  value: "alipay",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createElementVNode("img", {
                      style: {"width":"20px","height":"20px","margin-right":"5px"},
                      src: _imports_1
                    }, null, -1),
                    _createTextVNode(" 支付宝支付 ")
                  ])),
                  _: 1,
                  __: [9]
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, {
              style: {"width":"100%"},
              color: "#ef8b25",
              class: "footer-btn1",
              onClick: confirmEvent
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("确认支付")
              ])),
              _: 1,
              __: [11]
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_el_button, {
              link: "",
              plain: "",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (historyShow.value=true))
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode(" 查看明细记录 ")
              ])),
              _: 1,
              __: [12]
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: alipayShow.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((alipayShow).value = $event)),
      fullscreen: "",
      onClose: alipayClose
    }, {
      default: _withCtx(() => [
        (alipayShow.value)
          ? (_openBlock(), _createElementBlock("iframe", {
              key: 0,
              srcdoc: alipayHtml.value,
              frameborder: "no",
              border: "no",
              marginwidth: "0",
              marginheight: "0",
              scrolling: "0",
              width: "100%",
              height: "700px",
              style: {"overflow":"hidden"}
            }, null, 8, _hoisted_16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "扫一扫，微信支付",
      modelValue: wechatShow.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((wechatShow).value = $event)),
      fullscreen: "",
      onClose: wechatClose,
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _cache[14] || (_cache[14] = _createElementVNode("div", {
          id: "qrcode",
          style: {"width":"350px","height":"350px","margin":"auto"}
        }, null, -1)),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_button, {
            color: "#ef8b25 ",
            class: "footer-btn1",
            onClick: wxpaySuccess
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode("支付成功")
            ])),
            _: 1,
            __: [13]
          })
        ])
      ]),
      _: 1,
      __: [14]
    }, 8, ["modelValue"]),
    (historyShow.value)
      ? (_openBlock(), _createBlock(purchaseHistoryDialog, {
          key: 0,
          popupShow: historyShow.value,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (historyShow.value=false))
        }, null, 8, ["popupShow"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})